import "../types/meta";

export const CHECKOUT_URL = "https://ginutrition-en.impultienda.ar/checkout/";

export function trackCheckout(): void {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "InitiateCheckout");
  }
}
